import classNames from 'classnames';
import React from 'react';
import './ThemedText.scss';
const ThemedTextBase = ({ as: Component = 'span', variant = 'body', weight = 'normal', className = '', children, role, color, ...props }) => {
  const classes = classNames('themed-text', variant, weight, className, color);

  return (
    <Component className={classes} role={role} {...props}>
      {children}
    </Component>
  );
};

const ThemedText = {
  H1: props => <ThemedTextBase as='h1' variant='h1' {...props} />,
  H2: props => <ThemedTextBase as='h2' variant='h2' {...props} />,
  H3: props => <ThemedTextBase as='h3' variant='h3' {...props} />,
  H4: props => <ThemedTextBase as='h4' variant='h4' {...props} />,
  H5: props => <ThemedTextBase as='h5' variant='h5' {...props} />,
  H6: props => <ThemedTextBase as='h6' variant='h6' {...props} />,
  Span: props => <ThemedTextBase as='span' variant='span' {...props} />,
  P: props => <ThemedTextBase as='p' variant='p' {...props} />,
};

export default ThemedText;
